import React, { PureComponent } from 'react';
import HabitatsState from 'contexts/HabitatsState';

export default WrappedComponent => {
  return class extends PureComponent {
    static contextType = HabitatsState;
    render() {
      const consumedFromContext = this.context;
      return <WrappedComponent {...this.props} {...consumedFromContext} />;
    }
  };
};
